import Select, { components } from 'react-select';
import ControlSelect from "./control-select";
import ControlSelectSearch from "./control-select-search";
import { DndContext } from "@dnd-kit/core";
import { arrayMove, SortableContext } from "@dnd-kit/sortable";
import { cloneTemplate, deleteTemplate, updatePriority, updateTemplateStatus } from "../../dashboard/content/theme-builder/helper";
import { __ } from '@wordpress/i18n';
import TemplateItem from "../../dashboard/content/theme-builder/template-item";

export const MultiValueRemove = (props) => {
    if (props.data.isFixed) {
        return null;
    }
    return <components.MultiValueRemove {...props} />;
};

export const SelectControl = (props) => {
    return <Select {...props} />;
};

export const ThemeBuilderSelect = (props) => {
    return <ControlSelect {...props} />;
};

export const ThemeBuilderSelectSearch = (props) => {
    return <ControlSelectSearch {...props} />;
};

export const TemplateLists = ({ items, templates, setTemplates, openEditForm, activeTab, activeMenu }) => {

    const findTheIndex = (theItems, theId) => {
        return theItems.indexOf(theItems.find((element) => element.id == theId));
    }

    const updateStatus = async (id, oldStatus, newStatus) => {
        const updatedRecord = items[oldStatus].find(item => item.id === id);
        if (!updatedRecord) return;
        const lists = {
            [oldStatus]: items[oldStatus].filter(item => item.id !== id),
            [newStatus]: [...items[newStatus], updatedRecord]
        }
        await updateTemplateStatus(lists).then(res => {
            if (res) {
                setTemplates(lists)
            } 
        });
    };

    const reorderTemplateLists = async (event) => {
        if (!event.over) return;
        const { active, over } = event;
        const { id } = active;
        const { id: overId } = over;

        const activeIndex = findTheIndex(templates, id);
        const overIndex = findTheIndex(templates, overId);

        if (activeIndex !== overIndex) {
            let newVal = arrayMove(items[activeTab], activeIndex, overIndex);

            await updatePriority({ lists: newVal.map(item => item.id) }).then(res => {
                if (res) {
                    setTemplates({
                        ...items,
                        [activeTab]: newVal
                    });
                } else {
                    return;
                }
            });
        }
    };

    const duplicateTemplate = async (item) => {
        await cloneTemplate({
            type: activeMenu,
            data: {
                id: item.id,
                title: item.title + __(' Clone', 'jeg-elementor-kit'),
                type: activeMenu,
            },
        }).then(res => {
            if (res) {
                setTemplates(res.data)
            } 
        });
    }

    const deleteItem = async (id) => {

        await deleteTemplate({
            id: id,
        }).then(res => {
            if (res) {
                const newTemplate = {
                    ...items,
                    [activeTab]: items[activeTab].filter(item => item.id !== id)
                }
                setTemplates(newTemplate);
            }
        });

    }
    if (activeTab === 'draft') {
        return (
            <div className="list-content">
                {templates.map((item, index) => (
                    <TemplateItem key={index} priority={index + 1} item={item} openEditForm={openEditForm} activeTab={activeTab} activeMenu={activeMenu} updateStatus={updateStatus} duplicateTemplate={duplicateTemplate} deleteItem={deleteItem} />
                ))}
            </div>
        );
    }
    return (
        <DndContext onDragEnd={reorderTemplateLists}>
            <SortableContext items={templates}>
                <div className="list-content">
                    {templates.map((item, index) => (
                        <TemplateItem key={index} priority={index + 1} item={item} openEditForm={openEditForm} activeTab={activeTab} activeMenu={activeMenu} updateStatus={updateStatus} duplicateTemplate={duplicateTemplate} deleteItem={deleteItem} />
                    ))}
                </div>
            </SortableContext>
        </DndContext>
    );
};






